// Forces which CMS (Sanity or Sitecore) a page is resolved from, see `server/getServerSideProps.ts`. Sitecore
// stays the implicit default; this only re-attaches an override that was already active on the current page, so
// it survives client-side/container-hop navigation via `Link` instead of silently falling back to Sitecore.
//
// TODO: Sanity-migration-only escape hatch — delete this file and its usage in `Link.tsx` once every container
// has migrated to Sanity, alongside `_cms`/`allowCmsOverrideInProduction` in `server/getServerSideProps.ts`.
export const CMS_QUERY_PARAM = '_cms';

export const isCmsOverride = (value: unknown): value is 'sanity' | 'sitecore' => value === 'sanity' || value === 'sitecore';

export const withCmsParam = (url: string, cms: string): string => {
  if (url.includes(`${CMS_QUERY_PARAM}=`)) return url;
  const [pathAndQuery, hash] = url.split('#');
  const separator = pathAndQuery.includes('?') ? '&' : '?';
  const withParam = `${pathAndQuery}${separator}${CMS_QUERY_PARAM}=${cms}`;
  return hash !== undefined ? `${withParam}#${hash}` : withParam;
};
